
import '../../index.css'

import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link
} from "react-router-dom";

import Lang from '../Lang/Lang';
const Navbar = () => {
    return (
        <>


            <nav class="navbar navbar-expand-lg navbar-light bg-light fixed-top">

                <div class="container-fluid">
                    <button
                        class="navbar-toggler"
                        type="button"
                        data-mdb-toggle="collapse"
                        data-mdb-target="#navbarRightAlignExample"
                        aria-controls="navbarRightAlignExample"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                    >
                        <i class="fas fa-bars"></i>
                    </button>

                    <div class="navbar-collapse" id="navbarRightAlignExample">
                        <div class="container">
                            <Link to={'/'}>
                                <a class="navbar-brand">
                                    <img
                                        src="https://maorif.tj/images/banertj.png"
                                        height={65}
                                        alt="MDB Logo"
                                        loading="lazy"
                                    />
                                </a>
                            </Link>
                        </div>
                        <ul class="navbar-nav  ms-auto mb-2 mb-lg-0">

                            <li class="nav-item">
                                <a class="nav-link " aria-current="page" href="#">Асоси</a>
                            </li>

                            <li class="nav-item dropdown ">
                                <a
                                    class="nav-link dropdown-toggle"
                                    href="#"
                                    id="navbarDropdown"
                                    role="button"
                                    data-mdb-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    Президент
                                </a>


                                <ul class="dropdown-menu " aria-labelledby="navbarDropdown">
                                    <li>
                                        <Link to="/prezident-va-maorif" class="dropdown-item" >Президент ва маориф</Link>
                                    </li>
                                    <li>
                                        <a class="dropdown-item" href="http://www.president.tj/taxonomy/term/5/58">Вохӯриҳо</a>
                                    </li>
                                    <li>
                                        <a class="dropdown-item" href="http://www.president.tj/taxonomy/term/5/60">Суханрониҳо</a>
                                    </li>
                                    <li>
                                        <a class="dropdown-item" href="http://www.president.tj/taxonomy/term/5/62">Сафарҳои дохилӣ</a>
                                    </li>
                                    <li>
                                        <a class="dropdown-item" href="http://www.president.tj/taxonomy/term/5/64">Сафарҳои хориҷӣ</a>
                                    </li>
                                    <li>
                                        <a class="dropdown-item" href="http://www.president.tj/taxonomy/term/5/66">Фармонҳо</a>
                                    </li>
                                    <li>
                                        <a class="dropdown-item" href="http://www.president.tj/taxonomy/term/5/68">Паёмҳо</a>
                                    </li>
                                    <li>
                                        <a class="dropdown-item" href="http://www.president.tj/taxonomy/term/2/70">Барқияҳо</a>
                                    </li>
                                    <li>
                                        <a class="dropdown-item" href="http://www.president.tj/taxonomy/term/2/167">Суҳбатҳои телефонӣ</a>
                                    </li>
                                    <li>
                                        <a class="dropdown-item" href="http://www.president.tj/photoreports">Аксҳо</a>
                                    </li>

                                </ul>
                            </li>
                            <li class="nav-item dropdown">
                                <a
                                    class="nav-link dropdown-toggle"
                                    href="#"
                                    id="navbarDropdown"
                                    role="button"
                                    data-mdb-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    Тоҷикистон
                                </a>

                                <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                                    <li>
                                        <a class="dropdown-item" href="https://tg.wikipedia.org/wiki/%D0%A2%D0%BE%D2%B7%D0%B8%D0%BA%D0%B8%D1%81%D1%82%D0%BE%D0%BD">Тоҷикистон дар Википедия</a>
                                    </li>
                                    <li>
                                        <Link to="/qahramononi-tojikiston" class="dropdown-item" >Қаҳрамонони  Тоҷикистон</Link>
                                    </li>
                                    <li>
                                        <a class="dropdown-item" href="https://khovar.tj/category/r-zgori-odnamoni-na-ib/">Шахсиятҳои таърихиву фарҳангӣ</a>
                                    </li>
                                    <li>
                                        <a class="dropdown-item" href="https://khovar.tj/category/sajyo/">Сайёҳӣ ва ҳунарҳои мардумӣ </a>
                                    </li>
                                    <li>
                                        <a class="dropdown-item" href="#">Тоҷикистон дар YouTube</a>
                                    </li>

                                </ul>
                            </li>
                            <li class="nav-item dropdown">
                                <a
                                    class="nav-link dropdown-toggle"
                                    href="#"
                                    id="navbarDropdown"
                                    role="button"
                                    data-mdb-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    Вазорат
                                </a>

                                <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                                    <li>
                                        <Link to="/vazir" class="dropdown-item" >Вазир</Link>
                                    </li>
                                    <li>
                                        <Link to="/muovinoni-vazir" class="dropdown-item">МУОВИНОНИ ВАЗИР</Link>
                                    </li>
                                    <li>
                                        <Link to="/sohtor" class="dropdown-item" >Сохтор</Link>
                                    </li>
                                    <li>
                                        <Link to="/tarihi-vazorat" class="dropdown-item" >Таърихи вазорат</Link>
                                    </li>

                                </ul>
                            </li>
                            <li class="nav-item dropdown">
                                <a
                                    class="nav-link dropdown-toggle"
                                    href="#"
                                    id="navbarDropdown"
                                    role="button"
                                    data-mdb-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    Санадхо
                                </a>

                                <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                                    <li>
                                        <Link to={'/konstitutsiyai-umurii-toikiston'} class="dropdown-item" >Конститутсия </Link>
                                    </li>
                                    <li>
                                        <Link to={'/konunho'} class="dropdown-item" >Қонунҳо </Link>
                                    </li>
                                    <li>
                                        <Link to={'/karoru-farmono'} class="dropdown-item" >Қарору фармонҳо </Link>
                                    </li>
                                    <li>
                                        <Link to={'/strategiya-va-barnomao'} class="dropdown-item" >Стратегия ва барномаҳо </Link>
                                    </li>
                                    <li>
                                        <Link to={'/nizomnomao'} class="dropdown-item" >Низомномаҳо </Link>
                                    </li>
                                    <li>
                                        <Link to={'/karoroi-mushovara'} class="dropdown-item" >Қарорҳои мушовара </Link>
                                    </li>
                                    <li>
                                        <Link to={'/farmoisho'} class="dropdown-item" href="#">Фармоишҳо </Link>
                                    </li>
                                    <li>
                                        <Link to={'/tartibo'} class="dropdown-item" href="#">ТАРТИБ ВА ҚОИДАҲО </Link>
                                    </li>
                                    <li>
                                        <Link to={'/dasturo'} class="dropdown-item" href="#">Дастурҳо </Link>
                                    </li>


                                </ul>
                            </li>
                            <li class="nav-item dropdown">
                                <a
                                    class="nav-link dropdown-toggle"
                                    href="#"
                                    id="navbarDropdown"
                                    role="button"
                                    data-mdb-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    Зинаи тахсилот
                                </a>

                                <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                                    <li>
                                        <a class="dropdown-item" href="#">Таҳсилоти томактабӣ ва миёнаи умумӣ</a>
                                    </li>
                                    <li>
                                        <a class="dropdown-item" href="#">Таҳсилоти ибтидоӣ ва миёнаи касбӣ</a>
                                    </li>
                                    <li>
                                        <a class="dropdown-item" href="#">Таҳсилоти олӣ ва баъди дипломӣ</a>
                                    </li>


                                </ul>
                            </li>
                            <li class="nav-item">
                                <a
                                    class="nav-link dropdown-toggle"
                                    href="#"
                                >
                                    Илм ва инноватсия
                                </a>

                            </li>
                            <li class="nav-item dropdown">
                                <a
                                    class="nav-link dropdown-toggle"
                                    href="#"
                                    id="navbarDropdown"
                                    role="button"
                                    data-mdb-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    Китобхо
                                </a>

                                <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                                    <li>
                                        <a class="dropdown-item" href="#">Китобҳои дарсӣ</a>
                                    </li>
                                    <li>
                                        <a class="dropdown-item" href="#">Китобҳои бадеӣ</a>
                                    </li>
                                    <li>
                                        <a class="dropdown-item" href="#">КИТОБҲОИ ДАРСӢ ДАР ШАКЛИ 3D </a>
                                    </li>

                                </ul>
                            </li>

                            <li class="nav-item">
                                <Link to={'/vokunisho'} class="nav-link " aria-current="page" href="#">Вокунишхо</Link>
                            </li>
                            <li class="nav-item dropdown">
                                <a
                                    class="nav-link dropdown-toggle"
                                    href="#"
                                    id="navbarDropdown"
                                    role="button"
                                    data-mdb-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    Фаъолият
                                </a>

                                <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdown">
                                    <li>
                                        <a class="dropdown-item" href="#">Маблағгузорӣ</a>
                                    </li>
                                    <li>
                                        <a class="dropdown-item" href="#">Сохтмон</a>
                                    </li>
                                    <li>
                                        <a class="dropdown-item" href="#">Омор</a>
                                    </li>
                                    <li>
                                        <a class="dropdown-item" href="#">Эълон</a>
                                    </li>
                                    <li>
                                        <a class="dropdown-item" href="#">Махзани расмҳо</a>
                                    </li>
                                    <li>
                                        <a class="dropdown-item" href="#">Донишгоҳҳои Тоҷикистон</a>
                                    </li>
                                    <li>
                                        <a class="dropdown-item" href="#">Кадрҳо</a>
                                    </li>
                                    <li>
                                        <a class="dropdown-item" href="#">Вокунишҳо</a>
                                    </li>
                                    <li>
                                        <a class="dropdown-item" href="#">Равобити байналмилалӣ</a>
                                    </li>
                                    <li>
                                        <a class="dropdown-item" href="#">Маркази матбуотӣ </a>
                                    </li>
                                    <li>
                                        <a class="dropdown-item" href="#">Наворҳо </a>
                                    </li>
                                </ul>
                            </li>
                            <li class="nav-item dropdown">
                                <a
                                    class="nav-link dropdown-toggle"
                                    href="#"
                                    id="navbarDropdown"
                                    role="button"
                                    data-mdb-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    Муассисахои тобеъ
                                </a>

                                <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdown">
                                    <li>
                                        <a class="dropdown-item" href="#">Хадамоти давлатии назорат дар соҳаи маориф</a>
                                    </li>
                                    <li>
                                        <a class="dropdown-item" href="#">Академияи таҳсилоти Тоҷикистон </a>
                                    </li>
                                    <li>
                                        <a class="dropdown-item" href="#">Пажўҳишгоҳи рушди маориф </a>
                                    </li>
                                    <li>
                                        <a class="dropdown-item" href="#">Донишкадаи ҷумҳуриявии такмили ихтисос ва бозомўзии кормандони соҳаи маориф </a>
                                    </li>
                                    <li>
                                        <a class="dropdown-item" href="#">Маркази ҷумҳуриявии таълимию методӣ </a>
                                    </li>
                                    <li>
                                        <a class="dropdown-item" href="#">Маркази ҷумҳуриявии муассисаҳои таҳсилоти иловагӣ </a>
                                    </li>
                                    <li>
                                        <a class="dropdown-item" href="#">Маркази ҷумхуриявии технологияи информатсионӣ ва коммуникатсия </a>
                                    </li>
                                    <li>
                                        <a class="dropdown-item" href="#">Маркази ҷумхуриявии дарёфт ва рушди истеъдодҳо </a>
                                    </li>
                                    <li>
                                        <a class="dropdown-item" href="#">Маркази таълимии занон «Сарвар» </a>
                                    </li>
                                    <li>
                                        <a class="dropdown-item" href="#">Нашрияҳои соҳавӣ </a>
                                    </li>
                                    <li>
                                        <a class="dropdown-item" href="#">Маркази барномаҳои байналмилӣ </a>
                                    </li>

                                </ul>
                            </li>
                            <li class="nav-item dropdown">
                                <a
                                    class="nav-link dropdown-toggle"
                                    href="#"
                                    id="navbarDropdown"
                                    role="button"
                                    data-mdb-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    Лоиҳаҳо
                                </a>

                                <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdown">
                                    <li>
                                        <a class="dropdown-item" href="#">Рушди таҳсилоти олии касбӣ</a>
                                    </li>
                                    <li>
                                        <a class="dropdown-item" href="#">Таҷдид ва идомаи сохтмони мактабҳои миёна</a>
                                    </li>
                                    <li>
                                        <a class="dropdown-item" href="#">Сохтмон ва муҷаҳазгардонии мактабҳо</a>
                                    </li>
                                    <li>
                                        <a class="dropdown-item" href="#">Лоиҳаи USAID «Ҳамроҳ бихонем»</a>
                                    </li>
                                    <li>
                                        <a class="dropdown-item" href="#">Ҳифзи ҳуқуқи кӯдак</a>
                                    </li>

                                </ul>
                            </li>
                            <li class="nav-item dropdown">
                                <a
                                    class="nav-link dropdown-toggle"
                                    href="#"
                                    id="navbarDropdown"
                                    role="button"
                                    data-mdb-toggle="dropdown"
                                    aria-expanded="false"
                                >
                                    Тамос
                                </a>

                                <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdown">
                                    <li>
                                        <a class="dropdown-item" href="#">ТЕЛЕФОНҲО БАРОИ ТАМОС</a>
                                    </li>
                                    <li>
                                        <a class="dropdown-item" href="#">Нома ба мо</a>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                        <Lang />

                    </div>

                </div>

            </nav>


        </>
    )
}

export default Navbar;